let setupToken: string | null = null;

export const capturePasswordSetupToken = () => {
  if (window.location.pathname !== '/set-password') return;

  setupToken = new URLSearchParams(window.location.hash.slice(1)).get('token');
  window.history.replaceState(
    window.history.state,
    '',
    window.location.pathname + window.location.search
  );
};

export const getPasswordSetupToken = () => setupToken;

export const clearPasswordSetupToken = () => {
  setupToken = null;
};
